import React from 'react'
import MainNavbar from '../Header/MainNavbar'
import Footer from '../Footer/Footer'
import Topbar from '../Header/Topbar'
import GalleryGrid from '../Main/OtherSections/GalleryGrid'

const Gallery = () => {
  return (
    <>
        <GalleryGrid/>
    </>
  )
}

export default Gallery